import { fireUtagEvent } from '@garmin/support-analytics';

class LandingAnalytics {
  constructor() {
    this.category = 'ORMA Landing';
  }

  triggerPSCCaseIdAnalytics(label) {
    this.triggerAnalyticsEvent({
      event_category: 'ORMA Product ID',
      event_action: 'PSC Case',
      event_label: label,
    });
  }

  triggerCountrySelectionAnalytics(label) {
    this.triggerAnalyticsEvent({
      event_category: this.category,
      event_action: 'Country Identified',
      event_label: label,
    });
  }

  triggerSerialNumberAnalytics(valid = false, sn = '') {
    const invalidSN = sn ? `- ${sn}` : '';
    const action = 'SN Validation';
    const label = valid ? 'Serial Number Valid' : `Serial Number not found ${invalidSN}`;

    this.triggerAnalyticsEvent({
      event_category: this.category,
      event_action: action,
      event_label: label,
    });
  }

  triggerVerificationSubmissionAnalytics(valid, verificationResponse, sn = '') {
    const warrantyDesc = verificationResponse?.rmaWarrantyStatus?.warrantyDesc;

    if (warrantyDesc) {
      this.triggerAnalyticsEvent({
        event_category: this.category,
        event_action: 'Warranty Status',
        event_label: warrantyDesc,
      });
    }

    this.triggerAnalyticsEvent({
      event_category: this.category,
      event_action: 'Link',
      event_label: 'Submit',
    });
    this.triggerSerialNumberAnalytics(valid, sn);
  }

  // eslint-disable-next-line class-methods-use-this
  triggerAnalyticsEvent(manualAnalyticsEvent) {
    fireUtagEvent(manualAnalyticsEvent);
  }
}

export default LandingAnalytics;
